export const baseURL = " https://backend-paylocalplus.freedomuniversity.net/"  // "https://backend.contentreel.io/"; 
export const appName = "Paylocalplus";
export const loginFooter = "-paylocalplus.freedomuniversity.net" //NOTE DO NOT FORGET TO ADD . OR - FOR THE URL
export const navBar = "-paylocalplus.freedomuniversity.net"  //NOTE DO NOT FORGET TO ADD . OR - FOR THE URL